import { FormFields } from 'src/modules/user-input/FormFieldNames.ts';
import { getUserInputFormFieldKey } from 'src/modules/common/hooks/getUserInputFormFieldKey.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { UserInput } from 'src/modules/user-input/types.ts';
import { ValveProduct } from 'src/modules/valves/ValvesPageMapping.ts';
import { RegionsEnum } from 'src/generated/operations.ts';

type Props = {
    userInputState: UserInput;
    valve: ValveProduct;
    region: RegionsEnum;
}

export type DesignRow = { key:string; detectNamespace?: boolean} | string;

const createItem = (
    name: string,
    value: string | null | undefined,
): [string, string | null | undefined] => [name, value];

export const buildDesignDataContentRaw = ({ userInputState, valve, region }: Props) => {
    const fields: FormFields[] = userInputState.v100_2.length > 0 ? ['v100', 'v100_2'] : ['v100'];
    const isEffectivePV2Meaningful = valve.calcEffectivePV2 && valve.calcEffectivePV2 !== valve.calcEffectivePV;
    const is6way = valve.pattern?.raw.join('').includes('6');

    const emptyItem: [string, string | null | undefined][] = [];
    const calculatables: [string, string | null | undefined][] = [
        ...(valve.calcEffectiveDpv ? [
            createItem(MESSAGES.EffectiveDpv, valve.calcEffectiveDpv),
        ] : emptyItem),
        ...(is6way && valve.calcEffectiveDpv6way1 ? [
            createItem(MESSAGES.EffectiveDpv1, valve.calcEffectiveDpv6way1),
        ] : emptyItem),
        ...(is6way && valve.calcEffectiveDpv6way2 ? [
            createItem(MESSAGES.EffectiveDpv2, valve.calcEffectiveDpv6way2),
        ] : emptyItem),
        ...(valve.calcMinReqDpv ? [
            createItem(is6way ? MESSAGES.MinReqDpv1 : MESSAGES.MinReqDpv, valve.calcMinReqDpv),
        ] : emptyItem),
        ...(is6way && valve.calcMinReqDpv2 ? [
            createItem(MESSAGES.MinReqDpv2, valve.calcMinReqDpv2),
        ] : emptyItem),
        ...(valve.calcEffectivePV ? [
            createItem(MESSAGES.EffectivePV, valve.calcEffectivePV),
        ] : emptyItem),
        ...(is6way && valve.calcEffectivePV1 && isEffectivePV2Meaningful ? [
            createItem(MESSAGES.EffectivePV1, valve.calcEffectivePV1),
        ] : emptyItem),
        ...(is6way && valve.calcEffectivePV2 && isEffectivePV2Meaningful ? [
            createItem(MESSAGES.EffectivePV2, valve.calcEffectivePV2),
        ] : emptyItem),
        ...(valve.calcFlowVelocity ? [
            createItem(is6way ? MESSAGES.FlowVelocity1 : MESSAGES.FlowVelocity, valve.calcFlowVelocity),
        ] : emptyItem),
        ...(is6way && valve.calcFlowVelocity2 ? [
            createItem(MESSAGES.FlowVelocity2, valve.calcFlowVelocity2),
        ] : emptyItem),
    ];
    return [
        ...(fields
            .filter((name) => userInputState[name])
            .reduce((acc, name) => {
                acc.push({
                    key: getUserInputFormFieldKey(region, name),
                    detectNamespace: false,
                });
                acc.push(` ${userInputState[name]} `);
                acc.push({
                    key: userInputState[`${name}_u`],
                });
                acc.push(', ');
                return acc;
            }, [] as DesignRow[])),
        ...((calculatables)
            .reduce((acc, [k, v], currentIndex) => {
                if (!v) {
                    return acc;
                }
                acc.push({ key: k });
                acc.push(` ${v}`);
                if (currentIndex !== calculatables.length - 1) {
                    acc.push(', ');
                }
                return acc;
            }, [] as DesignRow[])
        ),
    ];
};
